"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _includes = _interopRequireDefault(require("core-js/library/fn/array/includes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class ArrayFieldItem extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onChange", (itemData, errorSchema) => {
      const _this$props = this.props,
            itemSchema = _this$props.itemSchema,
            index = _this$props.index; // set _action prop

      if (itemSchema.type === "object" && itemSchema.properties.hasOwnProperty('_action')) {
        if (itemData._action !== "delete" && itemData._action !== "create") {
          itemData._action = "update";
        }
      }

      console.log('arrayItem:onChange', itemData);
      this.props.onChangeIndex(index, itemData, errorSchema);
    });

    _defineProperty(this, "onMoveUp", () => {
      const index = this.props.index;
      this.props.onReorderIndex(index, index - 1);
    });

    _defineProperty(this, "onMoveDown", () => {
      const index = this.props.index;
      this.props.onReorderIndex(index, index + 1);
    });

    _defineProperty(this, "onRemoveItem", () => {
      const index = this.props.index;
      this.props.onRemoveIndex(index);
    });

    _defineProperty(this, "onAddBefore", item => {
      const index = this.props.index;
      this.props.onInsertAtIndex(item, index);
    });

    _defineProperty(this, "onAddAfter", item => {
      const index = this.props.index;
      this.props.onInsertAtIndex(item, index + 1);
    });
  }

  isItemRequired(itemSchema) {
    if (Array.isArray(itemSchema.type)) {
      // While we don't yet support composite/nullable jsonschema types, it's
      // future-proof to check for requirement against these.
      return !(0, _includes.default)(itemSchema.type, "null");
    } // All non-null array item types are inherently required by design


    return itemSchema.type !== "null";
  }

  render() {
    const _this$props2 = this.props,
          index = _this$props2.index,
          _this$props2$canRemov = _this$props2.canRemove,
          canRemove = _this$props2$canRemov === void 0 ? true : _this$props2$canRemov,
          _this$props2$canMoveU = _this$props2.canMoveUp,
          canMoveUp = _this$props2$canMoveU === void 0 ? true : _this$props2$canMoveU,
          _this$props2$canMoveD = _this$props2.canMoveDown,
          canMoveDown = _this$props2$canMoveD === void 0 ? true : _this$props2$canMoveD,
          itemSchema = _this$props2.itemSchema,
          itemData = _this$props2.itemData,
          itemUiSchema = _this$props2.itemUiSchema,
          itemId = _this$props2.itemId,
          itemIdSchema = _this$props2.itemIdSchema,
          itemIdPrefix = _this$props2.itemIdPrefix,
          itemErrorSchema = _this$props2.itemErrorSchema,
          autofocus = _this$props2.autofocus,
          disabled = _this$props2.disabled,
          readonly = _this$props2.readonly,
          uiSchema = _this$props2.uiSchema,
          registry = _this$props2.registry,
          onBlur = _this$props2.onBlur,
          onFocus = _this$props2.onFocus,
          rawErrors = _this$props2.rawErrors;

    const _orderable$removable$ = _extends({
      orderable: true,
      removable: true
    }, uiSchema["ui:options"]),
          orderable = _orderable$removable$.orderable,
          removable = _orderable$removable$.removable;

    const required = this.isItemRequired(itemSchema);
    const has = {
      moveUp: orderable && canMoveUp,
      moveDown: orderable && canMoveDown,
      remove: removable && canRemove
    };
    has.toolbar = Object.keys(has).some(key => has[key]);
    const SchemaField = registry.fields.SchemaField;
    return _react.default.createElement(SchemaField, {
      formData: itemData,
      schema: itemSchema,
      uiSchema: itemUiSchema,
      idSchema: itemIdSchema,
      errorSchema: itemErrorSchema,
      required: required,
      orderable: orderable,
      removable: removable,
      onBlur: onBlur,
      onFocus: onFocus,
      registry: _extends({}, registry, {
        formContext: _extends({}, registry.formContext, {
          onRemove: this.onRemoveItem
        })
      }),
      disabled: this.props.disabled,
      readonly: this.props.readonly,
      autofocus: autofocus,
      rawErrors: rawErrors,
      arrayIndex: index,
      isArrayItem: true,
      idPrefix: itemId,
      id: itemId,
      index: index,
      hasToolbar: has.toolbar,
      hasMoveUp: has.moveUp,
      hasMoveDown: has.moveDown,
      hasRemove: has.remove,
      onChange: this.onChange,
      onMoveUp: this.onMoveUp,
      onMoveDown: this.onMoveDown,
      onRemoveItem: this.onRemoveItem,
      onAddBefore: this.onAddBefore,
      onAddAfter: this.onAddAfter
    });
  }

}

var _default = ArrayFieldItem;
exports.default = _default;
module.exports = exports.default;